import React from "react";

export default function TextLink(props) {
	return (
		<span onClick={props.disabled ? null : props.onClick}>{props.children}</span>
	)
}
